"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlacementDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _EntityPickerModal = _interopRequireDefault(require("./utils/EntityPickerModal"));
var _useTranslations = require("../../utils/i18n/useTranslations");
var _PagePopover = _interopRequireDefault(require("../../utils/components/PagePopover"));
var _IssuePlacementContext = require("../../IssuePlacementContext");
var _alloyProvider = require("@adsk/alloy-provider");
var _processEntities = require("./utils/processEntities");
var _usePlacementFlow = require("./usePlacementFlow");
var _types = require("./types");
var _EntityDisplay = require("./EntityDisplay");
var _forbiddenExtensions = require("./forbiddenExtensions");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _extensionsToFilter = require("./extensionsToFilter");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _PlacementDropdownMenuUtils = require("./PlacementDropdownMenuUtils");
var _featureFlags = require("../../utils/featureFlags");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const forbiddenRootFolderName = "For the Field";
const PlacementDropdownContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const PlacementDropdown = _ref => {
  var _useCurrentProjectId;
  let {
    onChange,
    defaultIsOpen,
    onClose,
    error,
    issueType
  } = _ref;
  const {
    status,
    selectEntityType,
    selectEntity,
    associateEntity,
    resetToInitial,
    selectedEntityTypeConfig,
    entityType,
    entity,
    dropdownOptions,
    optionRenderer
  } = (0, _usePlacementFlow.usePlacementFlow)();
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase1Batch1);
  const disabledTooltip = T.translate("issueCreation.placement.forTheField.cantSelect3DFiles");
  const [channelInitiated, setChannelInitiated] = (0, _react.useState)(false);
  const [pageLoadTimeoutReached, setPageLoadTimeoutReached] = (0, _react.useState)(false);
  const resetState = (0, _react.useCallback)(() => {
    resetToInitial();
    setChannelInitiated(false);
    setPageLoadTimeoutReached(false);
  }, [resetToInitial]);
  const handleBrowserBackButtonClicked = (0, _react.useCallback)(() => {
    if (status === _types.PlacementFlowStatus.ENTITY_SELECTED) {
      resetState();
    }
  }, [status, resetState]);
  const showEntityPicker = status === _types.PlacementFlowStatus.ENTITY_TYPE_SELECTED;
  const getPlacementLink = (0, _IssuePlacementContext.useIssuePlacement)();
  const projectId = (_useCurrentProjectId = (0, _alloyProvider.useCurrentProjectId)()) !== null && _useCurrentProjectId !== void 0 ? _useCurrentProjectId : "";
  const viewerPageLink = (0, _react.useMemo)(() => !!selectedEntityTypeConfig && !!getPlacementLink ? getPlacementLink({
    projectId,
    // @ts-ignore
    document: selectedEntityTypeConfig.plugin.toolId === "documents" ? entity : undefined,
    // @ts-ignore
    sheet: selectedEntityTypeConfig.plugin.toolId === "sheets" ? entity : undefined,
    issueId: "",
    isIframe: true
  }) : "", [getPlacementLink, projectId, entity, selectedEntityTypeConfig]);
  const [isCloseAttempt, setIsCloseAttempt] = (0, _react.useState)(false);
  const handleClose = (0, _react.useCallback)(() => {
    setIsCloseAttempt(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (isCloseAttempt && !showEntityPicker && status === _types.PlacementFlowStatus.NOTHING_SELECTED) {
      onClose === null || onClose === void 0 || onClose();
    }
  }, [onClose, isCloseAttempt, showEntityPicker, status]);
  const handleOptionChange = (0, _react.useCallback)(option => {
    selectEntityType(option.value);
  }, [selectEntityType]);
  const handleChannelInit = (0, _react.useCallback)((_, port2) => {
    if (issueType) {
      port2.postMessage(issueType);
    }
    setChannelInitiated(true);
  }, [issueType]);
  (0, _react.useEffect)(() => {
    if (status === _types.PlacementFlowStatus.ENTITY_SELECTED) {
      setTimeout(() => {
        setPageLoadTimeoutReached(true);
      }, 5000);
    }
  }, [status]);
  const handleMessage = (0, _react.useCallback)(event => {
    if (typeof event.data !== "object") {
      return;
    }
    const {
      actionType,
      markup,
      pushpin,
      locationId,
      snapshotBlob
    } = event.data;
    switch (actionType) {
      case "close-viewer":
        resetState();
        break;
      case "confirm-stamp":
        if (markup) {
          associateEntity();
        } else {
          resetState();
        }
        onChange === null || onChange === void 0 || onChange(markup, {
          locationId
        });
        break;
      case "confirm-pushpin":
        if (pushpin) {
          associateEntity();
        } else {
          resetState();
        }
        onChange === null || onChange === void 0 || onChange(pushpin, {
          snapshotBlob
        });
        break;
      default:
        return;
    }
    setTimeout(() => onClose === null || onClose === void 0 ? void 0 : onClose());
  }, [associateEntity, onChange, resetState, onClose]);
  const dataViewPropsObj = (0, _react.useMemo)(() => {
    return {
      dataFilter: entities => (0, _processEntities.processEntities)({
        entities,
        disabledTooltip,
        forbiddenRootFolderName,
        forbiddenExtensions: _forbiddenExtensions.forbiddenExtensions,
        extensionsToFilter: _extensionsToFilter.extensionsToFilter
      })
    };
  }, [disabledTooltip]);
  const semanticIdentifier = "placement-dropdown";
  const NewDropdown = () => {
    const {
      controlProps,
      menuProps,
      closeMenu
    } = (0, _alloyReactDropdown.useDropdown)({
      items: dropdownOptions,
      selectedItem: null,
      defaultIsOpen,
      onSelectedItemChange: _ref2 => {
        let {
          selectedItem
        } = _ref2;
        handleOptionChange(selectedItem);
        closeMenu();
      },
      id: semanticIdentifier,
      onIsOpenChange: handleClose
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.Control, _extends({}, controlProps, {
      renderItem: _ref3 => {
        let {
          selectedItem
        } = _ref3;
        return optionRenderer(selectedItem);
      },
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.SingleSelectMenu, _extends({}, menuProps, {
      renderMenuItem: _ref4 => {
        let {
          item,
          ...props
        } = _ref4;
        return /*#__PURE__*/_react.default.createElement(_PlacementDropdownMenuUtils.PlacementDropdownMenuItem, {
          option: item,
          props: props,
          key: item.value
        });
      },
      "data-testid": "".concat(semanticIdentifier, "-menu")
    })));
  };
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.SelectBoxWrapper, {
    value: null,
    options: dropdownOptions,
    optionRenderer: optionRenderer,
    onChange: handleOptionChange,
    defaultIsOpen: defaultIsOpen,
    onClose: handleClose
  });
  const PlacementDropdown = shouldUseNewDropdown ? NewDropdown() : OldDropdown();
  return /*#__PURE__*/_react.default.createElement(PlacementDropdownContainer, {
    "data-testid": "PlacementDropdown"
  }, status === _types.PlacementFlowStatus.ENTITY_ASSOCIATED ? /*#__PURE__*/_react.default.createElement(_EntityDisplay.EntityDisplay, {
    entityType: entityType,
    entity: entity,
    error: error,
    onRemove: () => {
      onChange === null || onChange === void 0 || onChange(null, {});
      resetToInitial();
    }
  }) : PlacementDropdown, /*#__PURE__*/_react.default.createElement(_EntityPickerModal.default, {
    open: showEntityPicker,
    plugin: selectedEntityTypeConfig === null || selectedEntityTypeConfig === void 0 ? void 0 : selectedEntityTypeConfig.plugin,
    closeModal: resetToInitial,
    onSave: entity => {
      const entityToSelect = {
        ...entity,
        ...(entityType === "sheets" && {
          id: entity.sheetId
        })
      };
      selectEntity(entityToSelect);
    },
    title: selectedEntityTypeConfig === null || selectedEntityTypeConfig === void 0 ? void 0 : selectedEntityTypeConfig.panelTitle,
    dataViewProps: dataViewPropsObj
  }), /*#__PURE__*/_react.default.createElement(_PagePopover.default, {
    src: viewerPageLink,
    open: status === _types.PlacementFlowStatus.ENTITY_SELECTED,
    show: channelInitiated || pageLoadTimeoutReached,
    useChannelMessaging: true,
    onChannelInit: handleChannelInit,
    onMessage: handleMessage,
    onPopState: handleBrowserBackButtonClicked,
    hashUrl: "placement"
  }));
};
exports.PlacementDropdown = PlacementDropdown;
var _default = exports.default = PlacementDropdown;
//# sourceMappingURL=PlacementDropdown.js.map